export interface IAccessDoor {
  accessDoorId: string;
  accessDoorGroupId: string;
  type: boolean;
  label: string;
  firestoreUid: string;
  accessDoorType?: string;
  gpio: number;
  ip: string;
  doorId?: number;
  hikvisionUser: string;
  hikvisionPassword: string;
  status: boolean;
  uidCreatedBy: string;
  uidUpdatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export class AccessDoor {
  accessDoorId: string;
  accessDoorGroupId: string;
  type: boolean;
  label: string;
  firestoreUid: string;
  accessDoorType?: string;
  gpio: number;
  ip: string;
  doorId?: number;
  hikvisionUser: string;
  hikvisionPassword: string;
  status: boolean;
  uidCreatedBy: string;
  uidUpdatedBy: string;
  createdAt: string;
  updatedAt: string;

  constructor(data: IAccessDoor) {
    this.accessDoorId = data.accessDoorId;
    this.accessDoorGroupId = data.accessDoorGroupId;
    this.type = data.type;
    this.label = data.label;
    this.firestoreUid = data.firestoreUid;
    this.accessDoorType = data.accessDoorType;
    this.gpio = data.gpio;
    this.ip = data.ip;
    this.doorId = data.doorId;
    this.hikvisionUser = data.hikvisionUser;
    this.hikvisionPassword = data.hikvisionPassword;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }
}
